const sevenDayMenuFields = {
  VEGETARIAN: 'vegetarian',
  RECAPTCHA: 'recaptcha',
};

export default sevenDayMenuFields;
